import gql from 'graphql-tag'

export default gql`
  query getAccomplishments($id: String!) {
    getExpert(id: $id) {
      id

      certificates
      languages
      onboardingStep
    }
  }
`
